import { useMemo, useState } from "react"
import { Link } from "react-router-dom"
import DisplayManageTableItem from "./DisplayManageTableItem"
import ButtonCollapse from "./ButtonCollapse"
import ButtonRefresh from "./ButtonRefresh"
import InputSearch from "./InputSearch"
import LoadingCard from "./LoadingCard"
import API from "../utils/API"

export default function DisplayManageTable() {
  // State
  const [loaded, setLoaded] = useState(false)
  const [displays, setDisplays] = useState([])
  const [displaysFiltered, setDisplaysFiltered] = useState([])
  const [search, setSearch] = useState("")
  const [agencyFilter, setAgencyFilter] = useState("")

  // Comportements
  const getDisplays = () => {
    API.GET("/display", (response) => {
      setDisplays(response.data)
      setLoaded(true)
    })
  }

  useMemo(() => {
    getDisplays()
  }, [])

  const deleteDisplay = (id) => {
    let displaysCopy = displays.filter((display) => display.id !== id)
    setDisplays(displaysCopy)
  }

  const agencies = useMemo(() => {
    return [...new Set(displays.map((d) => d.agency).filter(Boolean))].sort()
  }, [displays])

  useMemo(() => {
    if (displays) {
      let displaysFilteredCopy = displays.filter(
        (display) =>
          (agencyFilter === "" || display.agency === agencyFilter) &&
          (display.code?.toLowerCase().includes(search) ||
            display.address?.toLowerCase().includes(search) ||
            display.city?.toLowerCase().includes(search) ||
            display.agency?.toLowerCase().includes(search) ||
            display.sector?.toLowerCase().includes(search))
      )
      setDisplaysFiltered(displaysFilteredCopy)
    }
  }, [search, agencyFilter, displays])

  // Rendu
  return (
    <div className="row">
      <div className="col">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Liste des emplacements</h3>
            <div className="card-tools">
              <Link to="/display/gestion/nouveau" className="btn btn-primary btn-sm mr-2">
                <i className="fas fa-plus"></i> Ajouter un emplacement
              </Link>
              <ButtonRefresh onClick={getDisplays} />
              <ButtonCollapse />
              <div className="float-left d-flex align-items-center mr-2">
                <select
                  className="form-control form-control-sm w-auto mr-2"
                  value={agencyFilter}
                  onChange={(e) => setAgencyFilter(e.target.value)}
                >
                  <option value="">Toutes les agences</option>
                  {agencies.map((agency) => (
                    <option key={agency} value={agency}>{agency}</option>
                  ))}
                </select>
                <InputSearch value={search} onChange={(event) => setSearch(event.target.value.toLowerCase())} />
              </div>
            </div>
          </div>
          <div className="card-body table-responsive p-0" style={{ display: "block" }}>
            <LoadingCard loaded={loaded}>
              {displays.length > 0 ? (
                <table className="table table-striped projects text-nowrap">
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Agence</th>
                      <th>Adresse</th>
                      <th>Ville</th>
                      <th>Type</th>
                      <th>Format</th>
                      <th>Secteur</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {displaysFiltered.map((display) => (
                      <DisplayManageTableItem display={display} deleteDisplay={deleteDisplay} key={display.id} />
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="alert alert-info m-3">
                  <h5>
                    <i className="icon fas fa-info" /> Aucun emplacement !
                  </h5>
                  Vous n'avez pas encore d'emplacements enregistrés.
                </div>
              )}
            </LoadingCard>
          </div>
        </div>
      </div>
    </div>
  )
}
